import { FundWithDealRes, OrganizationRes } from '@dealstack/shared/lib/generated';
import { Flex } from '@mantine/core';
import { FundsTable } from '@dealstack/frontend/app/pages/Organization/OrganizationFunds/components/FundsTable/FundsTable.tsx';
import { OrganizationSettingsView } from '@dealstack/frontend/app/pages/Organization/Organization.types';

interface Props {
	organization: OrganizationRes;
	onViewChange: (view: OrganizationSettingsView, fund: FundWithDealRes) => void;
}

export const OrganizationFunds = ({ organization, onViewChange }: Props) => {
	const handleViewLinkedDeals = (fund: FundWithDealRes) => {
		onViewChange(OrganizationSettingsView.FundDeals, fund);
	};

	if (!organization.id) {
		return null;
	}

	return (
		<Flex direction="column" h="100%" w="100%" p="1rem">
			<FundsTable
				organizationId={organization.id}
				onViewLinkedDeals={handleViewLinkedDeals}
			/>
		</Flex>
	);
};
